import activityTypes from '../activityTypes'

export default {
	[activityTypes.OPEN_ENDED_QUESTION]: 'oeq',
	[activityTypes.MULTIPLE_CHOICE_QUESTION]: 'mcq',
}
